import { BackendService } from '@/types/BackendService';
import axios from 'axios';

function HttpClient(service: BackendService = BackendService.Auth) {
	const _errorHandler = (error: any) => {
		console.error(error);
		return Promise.reject(error);
	};

	const _httpClient = axios.create({
		baseURL: service.toString(),
		timeout: 300000, // 5 mins
		headers: {
			'Content-Type': 'application/json',
		},
	});

	_httpClient.interceptors.request.use((config) => {
		const token =
			JSON.parse(localStorage?.getItem('user_token') || '{}').token?.AuthenticationResult
				?.AccessToken || '';

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	});

	_httpClient.interceptors.response.use((response) => {
		// Redirect to /account/logout if is unauthorized
		if (response.status === 401) {
			window.location.href = '/account/logout';
		}

		return response.data;
	}, _errorHandler);

	return {
		get: <T = any>(url: string, config = {}) => _httpClient.get<T>(url, config),
		post: <T = any>(url: string, data: any, config = {}) =>
			_httpClient.post<T>(url, data, config),
		patch: <T = any>(url: string, config = {}) => _httpClient.patch<T>(url, config),
		put: <T = any>(url: string, data: any, config = {}) =>
			_httpClient.put<T>(url, data, config),
		delete: <T = any>(url: string, config = {}) => _httpClient.delete<T>(url, config),
		client: _httpClient,
	};
}

export default HttpClient;
